import React from 'react';

const HRReportsPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default HRReportsPage;
